import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicEmailInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';

const PropertyOwnerAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent,DynamicCellInput:PhoneComponent,DynamicEmailInput:EmailComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput,DynamicCellInput,DynamicEmailInput};
// MainTransferID	
// UserID	
// TransferDate	
// FromShopID	
// ToShopID
  
const [inputProps, setInputProps] = useState({
  PropertyOwnerID: { name: 'PropertyOwnerID', value: props.PropertyOwnerID || '' },
  // CompanyID: { name: 'CompanyID', value: props.CompanyID || '' },
  PropertyOwnerName: { name: 'PropertyOwnerName', value: props.PropertyOwnerName || '' },
  OwnerEmail: { name: 'OwnerEmail', value: props.OwnerEmail || '' },
  OwnerContactNo: { name: 'OwnerContactNo', value: props.OwnerContactNo || '' },
  
});
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
// { Input: TextComponent, Props: { ...inputProps.PropertyOwnerID, setInputProps }, ColumnSize: 6 },
// { Input: TextComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 6 },
{ Input: TextComponent, Props: { ...inputProps.PropertyOwnerName, setInputProps }, ColumnSize: 6 },
{ Input: EmailComponent, Props: { ...inputProps.OwnerEmail, setInputProps }, ColumnSize: 6 },
{ Input: TextComponent, Props: { ...inputProps.OwnerContactNo, setInputProps }, ColumnSize: 6 },
];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Property Owner ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default PropertyOwnerAdd;
